export default {
    actions: {
        hide({ commit }) {
            commit("UNSET_SNACKBAR");
        },
        show({ commit }, message) {
            commit("SET_SNACKBAR", message);
        },
    },
    getters: {
        snackbarData(state) {
            let info = { status: state.snackbar, text: state.snackbarText };
            return info;
        },
    },
    mutations: {
        SET_SNACKBAR(state, payload) {
            state.snackbar = true;
            state.snackbarText = payload;
        },
        UNSET_SNACKBAR(state) {
            state.snackbar = null;
            state.snackbarText = "";
        },
    },
    namespaced: true,
    state: {
        snackbar: false,
        snackbarText: "",
    },
};
